"use client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import Login from "./components/Login.tsx";
import Signup from "./components/Signup.tsx";
import Dashboard from "./components/Dashboard.tsx";
import PrivateRoute from "./components/PrivateRoute.tsx";
import OTPVerification from "./components/OTPVerification.tsx";
import PasswordReset from "./components/PasswordReset.tsx";
import PasswordResetOTP from "./components/PasswordResetOTP.tsx";
import Agents from "./components/Agents.tsx";
import CallHistory from "./components/CallHistory.tsx";
import PhoneNumbers from "./components/PhoneNumbers.tsx";
import KnowledgeBase from "./components/KnowledgeBase.tsx";
import AccountPreferences from "./components/AccountPreferences.tsx";
import { ThemeProvider } from "./ThemeContext.tsx";
import AgentRouter from "./components/agents/AgentRouter.tsx";
import CheckYourEmail from "./components/CheckYourEmail.tsx";
import SetNewPassword from "./components/SetNewPassword.tsx";
import Billing from "./components/Billing.tsx";

function App() {
  return (
    <ThemeProvider>
      <ChakraProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* OTP Verification Routes - support both path formats */}
            <Route path="/verify-otp" element={<OTPVerification />} />
            <Route path="/otp-verification" element={<OTPVerification />} />

            <Route path="/reset-password" element={<PasswordReset />} />
            <Route path="/password-reset-otp" element={<PasswordResetOTP />} />
            <Route path="/check-your-email" element={<CheckYourEmail />} />
            <Route path="/set-new-password" element={<SetNewPassword />} />
            <Route path="/" element={<Login />} />
            <Route path="/*" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/agents"
              element={
                <PrivateRoute>
                  <Agents />
                </PrivateRoute>
              }
            />
            <Route
              path="/agents/:agentId"
              element={
                <PrivateRoute>
                  <AgentRouter />
                </PrivateRoute>
              }
            />
            <Route
              path="/call-history"
              element={
                <PrivateRoute>
                  <CallHistory />
                </PrivateRoute>
              }
            />
            <Route
              path="/phone-numbers"
              element={
                <PrivateRoute>
                  <PhoneNumbers />
                </PrivateRoute>
              }
            />
            <Route
              path="/knowledge-base"
              element={
                <PrivateRoute>
                  <KnowledgeBase />
                </PrivateRoute>
              }
            />
            <Route
              path="/billing"
              element={
                <PrivateRoute>
                  <Billing />
                </PrivateRoute>
              }
            />
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <AccountPreferences />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </ChakraProvider>
    </ThemeProvider>
  );
}

export default App;
